import React, { useEffect, useState } from 'react'

import {
  Button,
  CTALink,
  FadeSwap,
  Form,
  HeadingXSmall,
  Label,
  Notification,
  Spinner,
  SubmitButton,
} from '@pb/components'
import cn from 'classnames'
import { useSelector } from 'react-redux'

import { EXTERNAL_ROUTES } from 'App/constants'
import appSelectors from 'App/duck/selectors'

import selectors from '../../duck/selectors'
import styles from './UpgradeToClub.scss'
import UpgradeToClubFormContent from './UpgradeToClubFormContent'

const UpgradeToClub: React.FC<any> = ({
  shouldHideOptionalFields = false,
  shouldShowCancelButton = false,
  onCancelClick,

  subHeadingText,

  onSubmit,
}) => {
  const isProvincesLoading = useSelector(selectors.getIsProvincesLoading)
  const dateOfBirth = useSelector(appSelectors.getUserBirthDateISO)
  const isSubmitting = useSelector(selectors.getIsUpgradeLoading)
  const postUpgradeToClubError = useSelector(selectors.getPostUpgradeToClubError)
  const [notificationMessage, setNotificationMessage] = useState(null)

  useEffect(() => {
    setNotificationMessage(postUpgradeToClubError)
  }, [postUpgradeToClubError])

  const currentData = {
    dateOfBirth,
  }

  return (
    <div className={styles.container}>
      {notificationMessage && (
        <Notification type="error" onExit={() => setNotificationMessage(null)}>
          {notificationMessage}
        </Notification>
      )}
      <FadeSwap
        flag={isProvincesLoading}
        placeholder={<Spinner isRendered containerClassName={styles.spinner} />}
      >
        <HeadingXSmall Tag="h2" className={styles.subHeading}>
          {subHeadingText}
        </HeadingXSmall>
        <Form onSubmit={onSubmit} currentData={currentData}>
          <UpgradeToClubFormContent shouldHideOptionalFields={shouldHideOptionalFields} />
          <SubmitButton className={styles.button} shouldShowSpinner={isSubmitting}>
            <Label copyKey="hub.join.now" />
          </SubmitButton>
          {!shouldShowCancelButton && (
            <CTALink
              // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element; secondary: true; reset:... Remove this comment to see the full error message
              secondary
              reset={false}
              className={cn(styles.button, styles.secondaryButton)}
              fullWidth
              href={EXTERNAL_ROUTES.clubInfoPage}
              Tag="a"
            >
              <Label copyKey="hub.findout.more.title" />
            </CTALink>
          )}
          {shouldShowCancelButton && (
            <Button
              secondary
              className={cn(styles.button, styles.secondaryButton)}
              fullWidth
              onClick={onCancelClick}
            >
              <Label copyKey="checkout.cancel.cta" />
            </Button>
          )}
        </Form>
      </FadeSwap>
    </div>
  )
}

export default UpgradeToClub
